import { useState } from 'react';
import { Link } from 'react-router-dom';
import { DEMO_MODE } from '@/lib/demo';

/**
 * A slim, dismissible banner shown only in demo builds (VITE_DEMO_MODE=true).
 * Makes it unmistakable that this is a sandbox: no real payments, data may reset.
 */
export function DemoBanner() {
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem('souqli-demo-banner') === 'off'; } catch { return false; }
  });
  if (!DEMO_MODE || hidden) return null;

  const dismiss = () => {
    try { sessionStorage.setItem('souqli-demo-banner', 'off'); } catch { /* ignore */ }
    setHidden(true);
  };

  return (
    <div className="section-dark bg-ink text-cream text-[12px] px-4 py-2 flex items-center justify-center gap-2 flex-wrap relative">
      <span className="pill bg-gold text-ink text-[9px] font-semibold">DEMO</span>
      <span className="text-cream/90">
        You’re in a test sandbox - payments are <strong className="text-gold">simulated</strong> and data may be reset.
      </span>
      <Link to="/login" className="text-gold hover:underline">Use a demo login →</Link>
      <button
        onClick={dismiss}
        aria-label="Dismiss demo notice"
        className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 grid place-items-center rounded-full hover:bg-cream/10 text-cream/70 hover:text-cream"
      >×</button>
    </div>
  );
}
